"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PricingTable {
    constructor(selector) {
        this.maxHeightTableHeader = 0;
        this.selector = ".grid-plan-item";
        this.selector = selector || this.selector;
        this.tables = document.querySelectorAll(this.selector);
        console.log("PricingTable", this.tables);
        if (this.tables.length) {
            this.init();
        }
    }
    defineMaxHeight(selector) {
        if (!selector)
            return;
        let maxHeight = 0;
        this.tables.forEach((table) => {
            const tableHeader = table.querySelector(selector);
            const tableHeight = tableHeader === null || tableHeader === void 0 ? void 0 : tableHeader.clientHeight;
            if (tableHeight && tableHeight > maxHeight) {
                maxHeight = tableHeight;
            }
        });
        this.tables.forEach((table) => {
            const tableHeader = table.querySelector(selector);
            if (tableHeader) {
                tableHeader.style.height = `${maxHeight}px`;
            }
        });
    }
    init() {
        if (window.innerWidth >= 768) {
            this.defineMaxHeight(".grid-plan-item__header");
            this.defineMaxHeight(".grid-plan-item__list");
        }
        // Resize window event
        window.addEventListener("resize", () => {
            if (window.innerWidth >= 768) {
                this.defineMaxHeight(".grid-plan-item__header");
                this.defineMaxHeight(".grid-plan-item__list");
            }
            else {
                this.tables.forEach((table) => {
                    const tableHeader = table.querySelector(".grid-plan-item__header");
                    const tableList = table.querySelector(".grid-plan-item__list");
                    if (tableHeader) {
                        tableHeader.style.height = `auto`;
                    }
                    if (tableList) {
                        tableList.style.height = `auto`;
                    }
                });
            }
        });
    }
}
exports.default = PricingTable;
